import { type UseMutationOptions, useMutation } from '@tanstack/react-query'
import { httpDeleteManualRetouchedImages } from '@/features/photoset/http/photoset.http'
import { errorHandler } from '@/helpers/utils'

export const useDeleteManualRetouchedImages = ({
	photosetId,
	options
}: {
	photosetId: number
	options?: UseMutationOptions
}) => {
	return useMutation({
		...options,
		mutationFn: () =>
			httpDeleteManualRetouchedImages({ urlParams: { photosetId } }),
		onError: (error) => errorHandler(error),
		onSuccess: (data, variables, onMutateResult, context) => {
			options?.onSuccess?.(data, variables, onMutateResult, context)
		}
	})
}
